import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import { adminAPI } from '../../../api';

import {Modal} from '../../../components/Modal'

interface Props {
  show: boolean
  handleClose: () => void
  handleUpdated: () => void
}


const ContentIslamicAddModal : React.FC<Props> = ({show, handleClose, handleUpdated}) => {

  const [handling, setHandling] = useState(false)
  
  const [file, setFile] = useState<string | Blob | null>(null)

  const schema = Yup.object().shape({
    file: Yup.mixed().required('Required')
  });

  const formik = useFormik({
    initialValues: {
      'file': null
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (file) {
        setHandling(true)
        const data = new FormData()
        data.append('file', file)
        await adminAPI.addContentIslamic(data)
        formik.resetForm()
        handleUpdated()
        handleClose()
        setHandling(false)
      }
    }
  })

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files && e.target.files[0]
    setFile(selectedFile || null)
    formik.setFieldValue('file', selectedFile)
  };

  return <Modal show={show} handleClose={handleClose} dialogClassName="" title={`Add Islamic Content`}>
    <form
      className='form fv-plugins-bootstrap5 fv-plugins-framework'
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className='fv-row mb-5'>
        <input type='file' name='file' accept='.csv, .xlsx' onChange={handleFileChange}/>
        <label className='form-label fs-8 text-gray-600 mb-0'>Ensure your file includes two columns labeled "content" and "type" with a header row clearly specifying the column names.</label>
      </div>
      <div className="text-center">
        <button
          type='submit'
          className="btn btn-primary"
          disabled={handling || !formik.isValid}
        >
          {!handling && <span className='indicator-label'>Add</span>}
          {handling && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        
        <button type="button" className="btn btn-light ms-3" onClick={handleClose}>
          Close
        </button>
      </div>
    </form>
  </Modal>
}

export {ContentIslamicAddModal}